export const CHECKED_BAGS_ONE_CLICK = 'ALT_ALT4561';
export const HIDE_THIRD_OPTION_D = 'ALT_ALT4939_D';
export const HIDE_THIRD_OPTION_M = 'ALT_ALT4939_M';

export const TRIP_DETAILS_CABIN_BAGS_DESKTOP = 'ALT_ALT4986_D';
export const TRIP_DETAILS_CABIN_BAGS_MOBILE = 'ALT_ALT4986_M';

export const NON_PRIME_MERCHANDISING = 'ALT_ALT5522_M';
